import {Question} from "./question";
import { QuestionSetLabel } from "./question-set-label";
import { QuestionType } from "./question-type";

export class TextboxQuestion extends Question {
    private _answer:string;

    constructor() {
        super();
        this.type = QuestionType.Textbox;
        this.skip_scoring = true; 
    }

    public setSavedAnswer(answer:string, labels:QuestionSetLabel[]) {
        this._answer = answer;
	}

    // public set skip_scoring(v:boolean) {
    //     // make sure it always skip scoring.
    //     this.skip_scoring = true;
    // }

    public get answer() {
        return this._answer;
    }
    public set answer(v:string) {
        this._answer = v;
    }

    public get answerDisplayText() {
        return this._answer;
    }

    public get answerForSave() {
        return this._answer;
    }

    public hasAnswer(answer:string) {
        return this._answer == answer;
    }

    public get isFilledOut() : boolean {
		return this._answer != null;
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/models/textbox-question.ts